import React from 'react'
import { CheckBoxOutlineBlank } from '@material-ui/icons'

import { CheckboxInactiveProps } from './checkboxInactive.types'
import * as S from './../../fieldsInactive.styles'

export const CheckboxInactive = ({ item, ...props }: CheckboxInactiveProps) => {
    return (
        <S.FieldInactiveWrapper {...props}>
            <S.Header>
                <S.Title>{item.value}</S.Title>

                {item.required && <S.Required>*Required</S.Required>}
            </S.Header>

            <S.OptionsList>
                {item.options.map((option) => (
                    <S.OptionsListItem key={option.id}>
                        <CheckBoxOutlineBlank />
                        {option.value}
                    </S.OptionsListItem>
                ))}

                {item.hasOther && (
                    <S.OptionsListItem>
                        <CheckBoxOutlineBlank />
                        Other
                    </S.OptionsListItem>
                )}
            </S.OptionsList>
        </S.FieldInactiveWrapper>
    )
}
